import React from 'react';

const SkeletonLoading = () => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 sm:gap-3 md:gap-4 lg:gap-6">
      {Array.from({ length: 12 }).map((_, index) => (
        <div key={index}>
          <div className="skeleton-game-card">
            <div className="skeleton skeleton-game-image"></div>
            <div className="skeleton-content">
              <div className="skeleton skeleton-title"></div>
              <div className="skeleton skeleton-button"></div>
            </div>
          </div>
        </div>
      ))}
      <style>{`
        .skeleton {
            background: linear-gradient(90deg, #2a3a5a 25%, #3a4a6a 50%, #2a3a5a 75%);
            background-size: 200% 100%;
            animation: loading 1.5s infinite;
        }

        @keyframes loading {
            0% {
                background-position: 200% 0;
            }

            100% {
                background-position: -200% 0;
            }
        }

        .skeleton-game-card {
            background: linear-gradient(135deg, #1e2d4d 0%, #2a3a5a 100%);
            border-radius: 12px;
            padding: 12px;
            border: 2px solid #3a4a6a;
        }

        .skeleton-game-image {
            width: 100%;
            aspect-ratio: 1 / 1;
            border-radius: 8px;
            margin-bottom: 12px;
        }

        .skeleton-content {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }

        .skeleton-title {
            width: 80%;
            height: 18px;
            border-radius: 4px;
            margin-bottom: 8px;
        }

        .skeleton-button {
            width: 100%;
            height: 36px;
            border-radius: 6px;
        }
      `}

      </style>
    </div>
  );
};

export default SkeletonLoading;